// @file Logic that decides when to show comments drawer on mobile
// This was factored out to avoid circular dependencies between stores.
import { useExpandedPostStore } from '@@/pinia/expanded_post'
import { useCommentsStore } from '@@/pinia/surface_comments'
import { useSurfaceContainerSizeStore } from '@@/pinia/surface_container_size'
import type { ComputedRef } from 'vue'
import { computed } from 'vue'

export function useSurfaceCommentDrawer(): {
  xAddCommentDrawer: ComputedRef<boolean>
  xEditCommentDrawer: ComputedRef<boolean>
} {
  const surfaceContainerSizeStore = useSurfaceContainerSizeStore()
  const commentsStore = useCommentsStore()
  const expandedPostStore = useExpandedPostStore()

  const xAddCommentDrawer = computed(() => {
    return (
      surfaceContainerSizeStore.isPhone && commentsStore.isAddingNewComment && !expandedPostStore.xExpandedPostPanel
    )
  })

  const xEditCommentDrawer = computed(() => {
    return surfaceContainerSizeStore.isPhone && commentsStore.hasCommentBeingEdited
  })

  return { xAddCommentDrawer, xEditCommentDrawer }
}
